// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ewbalsQS0Is_V5FP815N{width:338px;padding:12px}.xJ9cUgWiAS4X6_StHz3x{border-top:1px solid var(--border-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTabs": `ewbalsQS0Is_V5FP815N`,
	"wrapSendLater": `xJ9cUgWiAS4X6_StHz3x`
};
export default ___CSS_LOADER_EXPORT___;
